export enum COVERAGE {
    SHEER = 'sheer-coverage',
    MEDIUM = 'medium-coverage',
    FULL = 'full-coverage'
}
